import type { IconSvgObject } from './types';

const VoiceIdIcon: IconSvgObject = [
  ["path", { d: "M12.0001 7V17M8.00006 9.22222V14.7778M16.0001 14.7778V9.22222", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V8M16 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V8M16 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V16M8 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default VoiceIdIcon;
